import autoTable from "jspdf-autotable";
import { PDF_COLORS, PDF_FONTS, PDF_LAYOUT } from "../../utils/pdfStyles";
import { asText } from "../../utils/pdfHelpers";

export const drawPacienteInfo = (doc, { plan, startY }) => {
  const nombreCompleto = asText(plan?.paciente_nombre, "NO ESPECIFICADO");
  const docIdentidad = plan?.paciente_tipo_id && plan?.paciente_identificacion
    ? `${plan.paciente_tipo_id} ${plan.paciente_identificacion}`
    : asText(plan?.Unic_ID, "-");
  const edad = plan?.edad ? `${plan.edad} años` : "-";
  const direccion = asText(plan?.direccion, "-");
  const contacto = asText(plan?.contacto, "-");
  const eps = asText(plan?.eps, "-");
  const fechaDiligenciamiento = asText(plan?.fecha_diligenciamiento, "-");
  const acompanante = asText(plan?.acompanante, "-");
  const contactoAcom = asText(plan?.contacto_acompanante, "-");

  autoTable(doc, {
    startY: startY,
    margin: { left: PDF_LAYOUT.marginX, right: PDF_LAYOUT.marginX, bottom: PDF_LAYOUT.marginBottom },
    theme: "plain",
    tableWidth: PDF_LAYOUT.contentWidth,
    head: [
      [
        {
          content: "1. INFORMACIÓN GENERAL DE LA PACIENTE",
          colSpan: 6,
          styles: {
            fillColor: PDF_COLORS.bgLight,
            textColor: PDF_COLORS.primaryDark,
            fontStyle: "bold",
            fontSize: 9,
            cellPadding: { top: 3.5, bottom: 3.5, left: 6, right: 6 },
            lineColor: PDF_COLORS.border,
            lineWidth: { top: 0.5, right: 0.5, bottom: 0.5, left: 3 },
          },
        },
      ],
    ],
    body: [
      [
        { content: "Paciente:" },
        { content: nombreCompleto },
        { content: "Documento:" },
        { content: docIdentidad },
        { content: "Edad:" },
        { content: edad },
      ],
      [
        { content: "Dirección:" },
        { content: direccion },
        { content: "Teléfono:" },
        { content: contacto },
        { content: "EPS:" },
        { content: eps },
      ],
      [
        { content: "Acompañante:" },
        { content: acompanante },
        { content: "Contacto:" },
        { content: contactoAcom },
        { content: "Diligenciado:" },
        { content: fechaDiligenciamiento },
      ],
    ],
    columnStyles: {
      0: { cellWidth: 70, fontStyle: "bold", textColor: PDF_COLORS.textDark },
      1: { cellWidth: 155, textColor: PDF_COLORS.textMuted },
      2: { cellWidth: 68, fontStyle: "bold", textColor: PDF_COLORS.textDark },
      3: { cellWidth: 85, textColor: PDF_COLORS.textMuted },
      4: { cellWidth: 75, fontStyle: "bold", textColor: PDF_COLORS.textDark },
      5: { cellWidth: 70, textColor: PDF_COLORS.textMuted },
    },
    styles: {
      font: PDF_FONTS.family,
      fontSize: 8,
      cellPadding: { top: 3, bottom: 3, left: 4, right: 4 },
      lineColor: PDF_COLORS.borderLight,
      lineWidth: 0.5,
      overflow: "linebreak",
    },
    alternateRowStyles: {
      fillColor: PDF_COLORS.bgLight,
    },
  });

  return doc.lastAutoTable.finalY + 5;
};
